"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionAvatarWrap = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _contactPickerTheme = require("../../contactPickerTheme");
const OptionAvatarWrap = (0, _styled.default)("div")`
    padding-right: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _contactPickerTheme.contactPickerTheme.option.avatar.paddingRight(themeMode);
}};
    display: flex;
    align-items: center;
    [aria-disabled="true"] & {
        opacity: 50%;
    }
`;
exports.OptionAvatarWrap = OptionAvatarWrap;
//# sourceMappingURL=OptionAvatarWrap.js.map